<script setup lang="ts">

</script>

<template>
  <div class="template-content">
    <div class="container">
      <h1>Privacyverklaring</h1>
      <ul>
        <li>
          <h2>Voorwoord</h2>
          <p>De ervaar-je-hartslag app hecht veel waarde aan de privacy van haar gebruikers. Deze app is ontwikkeld om mensen op een leuke en interactieve manier kennis te laten maken met hun hartslag en hoe deze werkt.</p>
        </li>
        <li>
          <h2>Verklaring</h2>
          <ol>
            <li>
              <h2>Geen medisch hulpmiddel</h2>
              <p>Let op: deze app is géén medisch meetinstrument. De metingen en ervaringen zijn bedoeld voor educatieve en informatieve doeleinden en mogen niet worden gebruikt voor medische diagnoses of monitoring.</p>
            </li>
            <li>
              <h2>Geen opslag van persoonsgegevens</h2>
              <p>Bij het gebruik van deze app worden geen persoonsgegevens of hartslaggegevens opgeslagen. Er worden geen gegevens verzameld die herleidbaar zijn tot een individu. Alles wat de app registreert, blijft lokaal in het systeem en wordt niet bewaard.</p>
            </li>
            <li>
              <h2>Verbinding met derden</h2>
              <p>Voor de werking van bepaalde onderdelen maakt de app gebruik van diensten van derde partijen. Hierbij kan er technische informatie, zoals apparaat- of verbindingsgegevens (bijvoorbeeld IP-adres), tijdelijk worden verwerkt door deze externe servers. Dit gebeurt uitsluitend om de functionaliteit van de app mogelijk te maken – niet om gebruikers te identificeren of gegevens op te slaan.</p>
            </li>
            <li>
              <h2>Veilig gebruik</h2>
              <p>We doen er alles aan om een veilige gebruikerservaring te bieden. Omdat de app geen persoonsgegevens opslaat en slechts in beperkte mate technische gegevens verwerkt, kunnen gebruikers de app met een gerust hart gebruiken.</p>
            </li>
          </ol>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.template-content {
  padding-top: 40px;
}

.container {
  margin: 0 20vw 0 20vw;
}

@media screen and (max-width: 800px) {
  .container {
    margin: 0 8vw 0 8vw;
  }
}

ul {
  list-style-type: none;
  padding-left: 0;
  margin-left: 0;
}

ol li::marker {
  font-size: 1.35rem;
  font-weight: bold;
}
</style>